import _ from 'lodash';

import { JOINED_COMMUNITY, LEFT_COMMUNITY } from '../../community/actions';
import { SET_MEMBERS, SET_CURRENT_MEMBER, SET_VIEWED_MEMBER, FOLLOW_IN_STATE, UNFOLLOW_IN_STATE } from '../actions';

const createStateBox = (state) => ({
  map: (f) => createStateBox(f(state)),
  extract: () => state,
});

export default (state = {}, { type, payload }) => {
  switch (type) {
    case JOINED_COMMUNITY:
      return createStateBox(state)
        .map((s) => updateField(s, payload, 'inCommunity', true))
        .extract();

    case LEFT_COMMUNITY:
      return createStateBox(state)
        .map((s) => updateField(s, payload, 'inCommunity', false))
        .extract();

    case FOLLOW_IN_STATE: {
      const followerUid = payload.follower.uid;
      const followedUid = payload.followed.uid;
      const inc = (count) => count + 1;
      return createStateBox(state)
        .map((s) => updateField(s, followerUid, 'followingCount', inc))
        .map((s) => updateField(s, followedUid, 'isSubscribed', true))
        .map((s) => updateField(s, followedUid, 'followerCount', inc))
        .extract();
    }

    case UNFOLLOW_IN_STATE: {
      const unfollowerUid = payload.unfollower.uid;
      const unfollowedUid = payload.unfollowed.uid;
      const dec = (count) => count - 1;
      return createStateBox(state)
        .map((s) => updateField(s, unfollowerUid, 'followingCount', dec))
        .map((s) => updateField(s, unfollowedUid, 'isSubscribed', false))
        .map((s) => updateField(s, unfollowedUid, 'followerCount', dec))
        .extract();
    }

    case SET_MEMBERS:
      return createStateBox(state)
        .map((s) => setMembers(s, payload))
        .extract();

    case SET_CURRENT_MEMBER:
    case SET_VIEWED_MEMBER:
      return createStateBox(state)
        .map((s) => setMember(s, payload.uid, payload))
        .extract();

    default:
      return state;
  }
};

function setMembers(state, membersList) {
  return membersList.reduce((newState, newMember) => setMember(newState, newMember.uid, newMember), { ...state });
}

function setMember(state, memberId, data) {
  const memberState = state[memberId];
  return {
    ...state,
    [memberId]: {
      ...memberState,
      ...data,
    },
  };
}

function updateField(state, memberId, fieldName, fieldValue) {
  const memberState = state[memberId];
  return {
    ...state,
    [memberId]: {
      ...memberState,
      [fieldName]: _.isFunction(fieldValue) ? fieldValue(memberState[fieldName]) : fieldValue,
    },
  };
}
